<template>
  <div id="app">
    <header v-if="isAuthenticated" class="app-header">
      <div class="container header-container">
        <div class="logo">
          <router-link to="/" class="logo-link">
            <img src="@/assets/logo.jpg" alt="Logo" class="logo-img" />
          </router-link>
        </div>

        <nav class="main-nav">
          <!-- Menus fixos (sempre visíveis) -->
          <template v-if="!isAdmin">
            <router-link to="/dashboard" class="nav-link">Registrar</router-link>
            <router-link to="/meus" class="nav-link">Meus Registros</router-link>
            <router-link to="/perfil" class="nav-link">Perfil</router-link>
            <a href="#" class="nav-link" @click.prevent="logout">Sair</a>
          </template>
          <template v-if="isAdmin">
            <router-link to="/admin/dashboard" class="nav-link">Dashboard</router-link>
            <router-link to="/admin/funcionarios" class="nav-link">Funcionários</router-link>
            <!-- <router-link to="/perfil" class="nav-link">Perfil</router-link> -->
          </template>

          <!-- Botão dropdown para os outros menus -->
          <div v-if="isAdmin" class="dropdown" @click="toggleMenu">
            <button class="menu-btn">Mais ⬇</button>
            <div v-if="showMenu" class="dropdown-content">
              <template v-if="!isAdmin">
                
              </template>
              <template v-if="isAdmin">
                <router-link to="/admin/localizacoes" class="dropdown-item">Cadastrar Localização</router-link>
                <router-link to="/admin/funcionarios/pontos" class="dropdown-item">Relatórios</router-link>
                <router-link to="/admin/feriados" class="dropdown-item">Gerenciar Feriados</router-link>
                <router-link to="/perfil" class="dropdown-item">Perfil</router-link>
                <!-- <router-link to="/admin/logs" class="dropdown-item">Logs</router-link> -->
                <a href="#" class="dropdown-item logout" @click.prevent="logout">Sair</a>
              </template>
              
            </div>
          </div>
        </nav>
      </div>
    </header>

    <main class="main-content">
      <router-view />
    </main>

    <footer class="app-footer">
      <div class="container">
        <p>&copy; Planned - Sistema Interno</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      showMenu: false
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isAdmin() {
      return this.$store.state.user?.is_admin === true;
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    }
  },
  created() {
    this.$store.dispatch('checkAuth');
  }
}
</script>

<style scoped>
.app-header {
  background-color: #2c2d2e;
  color: #fff;
  padding: 0.5rem 1rem;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo a {
  color: #fff;
  font-weight: bold;
  font-size: 1.3rem;
  text-decoration: none;
}
.logo-link {
  display: inline-flex;
  align-items: center;
}
.logo-img {
  height: 38px;
  width: auto;
  display: block;
}

.main-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.nav-link {
  color: #fff;
  text-decoration: none;
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  transition: background 0.2s;
}

.nav-link:hover {
  background-color: #2563eb;
  color: #fff;
}

.menu-btn {
  background-color: #3b82f6;
  color: #fff;
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  cursor: pointer;
}

.menu-btn:hover {
  background-color: #2563eb;
}

.dropdown {
  position: relative;
}

.dropdown-content {
  position: absolute;
  top: 2.5rem;
  right: 0;
  background-color: #fff;
  color: #1e293b;
  min-width: 180px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  overflow: hidden;
  z-index: 1000;
}

.dropdown-item {
  display: block;
  padding: 0.6rem 1rem;
  text-decoration: none;
  color: inherit;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background-color: #e2e8f0;
}

.dropdown-item.logout {
  color: #b91c1c;
  font-weight: bold;
}

/* Main */
.main-content {
  padding: 2rem;
  background-color: #f1f5f9;
  min-height: calc(100vh - 120px);
}

/* Footer */
.app-footer {
  background-color: #2c2d2e;
  color: #fff;
  padding: 0.5rem 1rem;
  text-align: center;
}
</style>
